import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useQueryClient } from 'react-query'
import { TourGuide } from '../../components'
import { useGlobalStore } from '../../store'

import { Sidebar, Topbar, Footer } from '../components'

import { MainContainer, MiddleContainer, RightSideContainer, Container } from './style'

const PostLogin = (props) => {
  const { children, pageTitle, pageSubTitle, activePage = '', actions } = props
  const { isTourGuideActive } = useGlobalStore()
  const queryClient = useQueryClient()

  useEffect(() => {
    queryClient.clear()
  }, [])

  return (
    <>
      <MainContainer>
        <Sidebar activePage={activePage} />
        <RightSideContainer>
          <Topbar pageTitle={pageTitle} pageSubTitle={pageSubTitle} actions={actions} />
          <MiddleContainer>
            <Container>{children}</Container>
            <Footer notMainPage={false} />
          </MiddleContainer>
        </RightSideContainer>
      </MainContainer>

      {isTourGuideActive && <TourGuide type='postLogin' />}
    </>
  )
}

PostLogin.propTypes = {
  children: PropTypes.node,
  pageTitle: PropTypes.string,
  pageSubTitle: PropTypes.string,
  activePage: PropTypes.string,
  actions: PropTypes.array,
}

export default PostLogin
